import { getItem } from "../../shared/shop-catalog";
import { drawCharacterSprite } from "../game/entities/CharacterSprite";
import { drawHatBack, drawHatFront } from "../game/entities/HatAccessory";

/**
 * Draw a player's equipped character (+ hat) as a circular avatar centred at
 * (cx, cy) with diameter `d`. Returns false without drawing when `charId` isn't a
 * known built-in character (e.g. a custom/player-drawn skin, or missing data) so
 * the caller can fall back to an initial bubble.
 */
export function drawCharacterAvatar(
  ctx: CanvasRenderingContext2D,
  charId: string | null,
  hatId: string | null,
  cx: number,
  cy: number,
  d: number,
): boolean {
  // A logged-in author with nothing equipped is using the starter character; only
  // custom/player-drawn skins (unresolvable here) fall through to the initial bubble.
  const item = getItem(charId ?? "char.emerald");
  if (!item || item.slot !== "character") return false;
  const hatItem = hatId ? getItem(hatId) : null;
  const hatRender = hatItem && hatItem.slot === "hat" ? hatItem.render : null;

  ctx.save();
  // Soft circular backdrop so the sprite reads as a profile photo on the navy bg.
  ctx.fillStyle = "#cdd6e6";
  ctx.beginPath();
  ctx.arc(cx, cy, d / 2, 0, Math.PI * 2);
  ctx.fill();
  ctx.clip(); // keep the sprite inside the circle
  ctx.translate(cx, cy + d * 0.14); // nudge down so the body (not just the hat) is centred
  const s = d / 52;
  ctx.scale(s, s);
  const anim = { propAngle: 0.6, bobTime: 0.4, flapTime: 0 };
  if (hatRender) drawHatBack(ctx, 14, hatRender, anim);
  drawCharacterSprite(ctx, 14, item.render, { bobTime: 0.4, flapTime: 0 });
  if (hatRender) drawHatFront(ctx, 14, hatRender, anim);
  ctx.restore();
  return true;
}
